var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.$auth.ready()
    ? _c(
        "div",
        { staticClass: "admin-home-container" },
        [
          _vm.userLogged ? _c("navbar") : _vm._e(),
          _vm._v(" "),
          _vm.userLogged
            ? _c("div", { staticClass: "title" }, [
                _vm._v(
                  "\n        " + _vm._s(_vm.$t(_vm.$route.name)) + "\n    "
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "transition",
            { attrs: { name: "fade", mode: "out-in" } },
            [_c("router-view", { key: _vm.$route.fullPath })],
            1
          ),
        ],
        1
      )
    : _c("div", [_vm._v("\n    Loading ...\n")])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }